module.exports = __webpack_public_path__ + "img/vertical_7_5_8011.fed90109.png";